
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  props: {
    inputLabel: String,
    inputType: String,
    idComponent: String,
    classDiv: String,
    disabledInput: Boolean,
    mask: [String, Array],
    value: [String, Number],
    idInput: String,
    idLabel: String,
    maxlength: Number,
    required: {
      type: Boolean,
      default: false,
    },
  },
})
export default class InputText extends Vue {
  keyUpPress() {
    this.$emit("keyUpFunction");
  }

  inputChange() {
    this.$emit("changeFunction");
  }

  inputFocus() {
    this.$emit("focusFunction");
  }
}
